import type { ReferenceGate, ReferenceScores } from "@/types";

/**
 * How a version's scores read on the 검토 tab (TC 개선 Loop 결정 4). Two gates, each on its own rubric:
 * 니즈 (rubric_v3) and 품질 (common rubric, answer-quality part only). A flagged gate marks the version
 * 탈락 예정 — nothing is dropped; the reviewer still decides.
 */

export const GATE_TITLE = { needs: "니즈 · rubric_v3", quality: "품질 · common rubric" } as const;

const REASON_TEXT: Record<string, string> = {
  v3_unmet: "충족하지 못한 기준이 있음",
  v3_not_higher: "TC 답변보다 v3 점수가 높지 않음",
  fatal_penalty: "지어내기·하지 않은 작업 성공 주장 감점",
  common_not_higher: "TC 답변보다 답변 품질 점수가 높지 않음",
  v3_missing: "v3 점수 없음",
  tc_v3_missing: "비교할 TC 답변 점수 없음 (Batch Test 필요)",
  common_missing: "common rubric 점수 없음",
  tc_common_missing: "TC 답변의 common rubric 점수 없음",
};

export const reasonText = (code: string) => REASON_TEXT[code] ?? code;

export const score2 = (value: number | null | undefined) => (value == null ? "–" : value.toFixed(2));

export function gateLabel(gate: ReferenceGate): string {
  if (gate.state === "flag") return "탈락 예정";
  if (gate.state === "pending") return "점수 대기";
  return "통과";
}

export const GATE_TONE: Record<ReferenceGate["state"], string> = {
  flag: "border-destructive-line bg-destructive-surface text-destructive",
  pending: "border-border bg-surface-input text-muted-foreground",
  pass: "border-success-line bg-success-surface text-success",
};

/** The list cell: the Reference's two scores, or nothing yet. */
export function compactScores(scores: ReferenceScores | null | undefined): string | null {
  const ref = scores?.reference;
  if (!ref || (!ref.v3 && !ref.common)) return null;
  return `v3 ${score2(ref.v3?.final)} · common ${score2(ref.common?.answer_quality)}`;
}
